const faqData = [
  {
    category: "📦 Shipping",
    questions: [
      {
        question: "What are GutterAll's shipping options and rates?",
        answer: `We offer various shipping options for standard items and specialized shipping for gutters:

        Standard Items:
        • Local pickup (Free)
        • Standard Ground (2-5 business days)
        • Express Shipping (1-2 business days)
        
        Gutter & Downspout Shipping:
        • LTL Freight
        • Full Truckload
        • Curbside Delivery
        • Liftgate Service Available`
      },
      {
        question: "Are there any length restrictions for shipping gutters?",
        answer: "Yes, there are length restrictions due to shipping carrier limitations:\n\n• Standard shipping: Maximum length of 8 feet\n• Freight shipping: Can accommodate longer sections up to 20 feet\n\nFor specific length requirements, please contact our customer service."
      },
      {
        question: "Do you offer bulk order shipping?",
        answer: "We welcome bulk orders and offer special shipping rates for large quantities. Contact our sales team for a custom quote on your bulk order shipping."
      }
    ]
  },
  {
    category: "🔄 Returns & Replacements",
    questions: [
      {
        question: "What is GutterAll's return policy?",
        answer: "We offer a 30-day return policy on most items. Here are the key points:\n\n• Items must be in original, unused condition\n• Original packaging is required\n• Customer is responsible for return shipping costs\n• Refunds are processed within 5-7 business days after inspection\n\nPlease note that custom-cut gutters and special orders may not be eligible for return."
      },
      {
        question: "How do I request a replacement for a defective product?",
        answer: "If you receive a defective product:\n\n1. Contact our customer service within 30 days of receipt\n2. Provide order number and photos of the defect\n3. Our team will review and approve the replacement\n4. We'll ship a replacement at no cost to you\n\nAll replacements are subject to professional inspection upon return."
      }
    ]
  },
  {
    category: "🛠️ Installation & Support",
    questions: [
      {
        question: "Do you offer installation services?",
        answer: "While we specialize in providing high-quality gutter materials for DIY installation, we also offer professional installation services through our network of approved partners. Here's what we provide:\n\n• Comprehensive DIY installation guides and video tutorials\n• Customer support for DIY projects\n• Professional installation services via approved local partners\n• Recommendations for certified installers in your area\n\nWhether you choose to DIY or opt for professional installation, we ensure you have the support you need for a successful gutter project."
      },
      {
        question: "How can I get help with my DIY gutter installation?",
        answer: "We offer several resources to support both DIY and professional gutter installation:\n\n• Detailed installation guides on our website\n• Video tutorials for each step of the process\n• Live chat support during business hours\n• Email support for technical questions\n• Phone consultation with our gutter experts\n• Referrals to our approved installation partners\n\nDon't hesitate to reach out if you need assistance at any stage of your project, whether you're installing yourself or considering professional help."
      }
    ]
  }
];

class FAQApp {
  constructor(container) {
    this.container = container;
    this.render();
    this.addEventListeners();
  }

  render() {
    this.container.innerHTML = `
      <div class="tab-container">
        <button class="tab-button active" data-tab="faq">FAQ</button>
        <button class="tab-button" data-tab="howto">How-To Guides</button>
      </div>
      <div class="content-container">
        ${this.renderFAQContent()}
      </div>
    `;
  }

  renderFAQContent() {
    return faqData.map(category => `
      <div class="category-section">
        <h2>${category.category}</h2>
        ${category.questions.map((q, i) => `
          <div class="accordion-item">
            <button class="accordion-button" data-index="${i}">
              ${q.question}
              <span class="icon">+</span>
            </button>
            <div class="accordion-content">
              ${q.answer.replace(/\n/g, '<br>')}
            </div>
          </div>
        `).join('')}
      </div>
    `).join('');
  }

  addEventListeners() {
    this.container.querySelectorAll('.accordion-button').forEach(button => {
      button.addEventListener('click', () => {
        const content = button.nextElementSibling;
        const isActive = content.classList.contains('active');
        
        // Close all other accordions
        this.container.querySelectorAll('.accordion-content').forEach(c => {
          c.classList.remove('active');
          c.previousElementSibling.querySelector('.icon').textContent = '+';
        });

        // Toggle current accordion
        if (!isActive) {
          content.classList.add('active');
          button.querySelector('.icon').textContent = '−';
        }
      });
    });

    this.container.querySelectorAll('.tab-button').forEach(button => {
      button.addEventListener('click', () => {
        this.container.querySelectorAll('.tab-button').forEach(b => b.classList.remove('active'));
        button.classList.add('active');
        // Add tab switching logic here
      });
    });
  }
}

// Initialize the app
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('faq-app');
  if (container) {
    new FAQApp(container);
  }
});